import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BypassSecurityPipe } from '../../pipes/bypass-security.pipe';
import { VideoIntroBlockComponent } from '../video-intro-block/video-intro-block.component';
import { CallToActionWithCountdownComponent } from '../call-to-action-with-countdown/call-to-action-with-countdown.component';
import { ArticleComponent } from '../article/article.component';
import { SponsorBannerComponent } from '../sponsor-banner/sponsor-banner.component';
import { ArticleListComponent } from '../article-list/article-list.component';
import { ArticleWithCollapsiblePanelsComponent } from '../article-with-collapsible-panels/article-with-collapsible-panels.component';
import { EventListComponent } from '../event-list/event-list.component';
import { PdfDownloadListComponent } from '../pdf-download-list/pdf-download-list.component';
import { ContactFormComponent } from '../contact-form/contact-form.component';

@Component({
  selector: 'app-sections',
  standalone: true,
  imports: [
    CommonModule,
        VideoIntroBlockComponent,
        CallToActionWithCountdownComponent,
        ArticleComponent,
        ArticleListComponent,
        ArticleWithCollapsiblePanelsComponent,
        SponsorBannerComponent,
        EventListComponent,
        PdfDownloadListComponent,
        ContactFormComponent],
  templateUrl: './sections.component.html',
  styleUrls: ['./sections.component.less']
})
export class SectionsComponent {
  @Input() data: any;
}
